import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import YouTube from 'react-youtube';
import { Collapse } from 'antd';
import isArray from 'lodash/isArray';
import { ISnippet } from 'types';
import CopyToClipboard from 'components/common/copyToClipboard';

import './style.scss';

const { Panel } = Collapse;

interface IProgramsContentProps {
  programsData: ISnippet[];
}
interface YouTubePlayerEvent {
  target: {
    stopVideo: () => void;
  };
}

function ProgramsContent({ programsData }: IProgramsContentProps) {
  const [pitchVideoPlayerTarget, setPitchVideoPlayerTarget] = useState<YouTubePlayerEvent | null>();
  const [searchParams, setSearchParams] = useSearchParams();

  const handleChange = (data: string[] | string) => {
    const key = isArray(data) ? data[0] : data;

    key ? searchParams.set('activeKey', key) : searchParams.delete('activeKey');
    setSearchParams(searchParams);

    pitchVideoPlayerTarget?.target?.stopVideo();
    setPitchVideoPlayerTarget(null);
  };

  const defaultActiveKey = searchParams.get('activeKey') || '';

  return (
    <div className="programs-content">
      <Collapse
        accordion
        onChange={handleChange}
        defaultActiveKey={defaultActiveKey}
      >
        {programsData.map(item => (
          <Panel
            header={item.title}
            key={item.resourceId?.videoId}
            extra={(
              <div onClick={e => e.stopPropagation()}>
                <CopyToClipboard
                  text={`${window.location.href}${!defaultActiveKey ? `&activeKey=${item.resourceId.videoId}` : ''}`}
                />
              </div>
            )}
          >
            <YouTube
              className="video-content__player"
              videoId={item.resourceId?.videoId}
              onPlay={(e: YouTubePlayerEvent) => setPitchVideoPlayerTarget(e)}
              opts={{
                playerVars: {
                  rel: 0,
                  showinfo: 0,
                },
              }}
            />
          </Panel>
        ))}
      </Collapse>
    </div>
  );
}

export default ProgramsContent;
